
<template>
  <div style="position: fixed; width: 100%; height: 100%; top:0; left: 0; background-color: rgba(0,0,0,0.6);">
    <div style="position: absolute; top:50%; left:50%; transform: translate(-50%, -50%); width: calc(100% - 20px); max-width: 1500px; height: 90%; background-color: white; border-radius: 10px; padding: 10px; overflow-y: auto;">
      <div class="container-fluid" v-if="item != null">
        <div class="row section-container">
          <div class="col-8 text-left">
            <h2>Air House</h2>
          </div>
          <div class="col-4 text-right">
            <button v-on:click="printAirHouse()">Print</button>
          </div>
        </div>

        <div class="container-fluid text-left house-bill" style="padding-bottom: 100px; margin-top: 50px;">
          <div class="row">
            <div class="col-12" style="font-weight: bold;">
              HOUSE AIRWAY BILL
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              MAWB :{{manifest.awb}}
            </div>
            <div class="col-6">
              HOUSE No
              <input v-model="item.blNumber" class="form-control"/>

            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Shipper's Name and Address
              <input class="form-control" v-model="item.shipperTitle"/>
              <input class="form-control" v-model="item.shipperAddress1"/>
              <input class="form-control" v-model="item.shipperAddress2"/>
              <input class="form-control" v-model="item.shipperAddress3"/>
              <input class="form-control" v-model="item.shipperPostCode"/>
              <input class="form-control" v-model="item.shipperTel"/>
            </div>
            <div class="col-6">
              HOUSE AIR WAYBILL <button @click="openAgentSelector('issuer', 'agents')">Search</button>
              <br>
              issued by<br>
              <div style="width: 100%; display: flex;">
                <div style="width: calc(100% - 100px);"><input class="form-control" v-model="item.issuerTitle" :disabled="item.issuerId > 0" placeholder="Name"/></div>
                <div style="width: 100px;"><button v-if="item.issuerId > 0" @click="item.issuerId = 0; item.issuerTitle = '';">Manual</button></div>
              </div>
              <input class="form-control" v-model="item.issuerAddress1"/>
              <input class="form-control" v-model="item.issuerAddress2"/>
              <input class="form-control" v-model="item.issuerAddress3"/>
              <input class="form-control" v-model="item.issuerPostCode"/>
              <input class="form-control" v-model="item.issuerTel"/>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Consignee Name and Address
<!--              <button @click="openAgentSelector('customer')">Search</button><br>-->
<!--              <div style="width: 100%; display: flex;">-->
<!--                <div style="width: calc(1005 - 100px);"><input class="form-control" v-model="item.consigneeTitle" :disabled="item.consigneeId > 0"/></div>-->
<!--                <div style="width: 100px;"></div>-->
<!--              </div>-->
              <input class="form-control" v-model="item.consigneeTitle"/>
              <input class="form-control" v-model="item.consigneeAddress1"/>
              <input class="form-control" v-model="item.consigneeAddress2"/>
              <input class="form-control" v-model="item.consigneeAddress3"/>
              <input class="form-control" v-model="item.consigneePostCode"/>
              <input class="form-control" v-model="item.consigneeTel"/>
            </div>
            <div class="col-6">
              Accounting Information
              <br>
              <textarea rows="5" v-model="item.accountingInfo" class="form-control"/>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Issuing Carrier's Agent Name and City
              <br>
              UKO SHIPPING LTD.<br>
              TEL: 01420 430 750

            </div>
            <div class="col-6">

            </div>
            <div class="col-3">
              Agent IATA code
              <br>
              91-4 5500/0011
            </div>
            <div class="col-3">
              Account No
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              Airport of Department (Addr of First Carrier) and Requested Routing<br>
              {{manifest.origin}}
            </div>
          </div>

          <div class="row">
            <div class="col-1">
              To<br>
              {{manifest.to1}}
            </div>
            <div class="col-2">
              by first Carrier
              <br>
              {{manifest.by1}}
            </div>
            <div class="col-1">
              To<br>
              {{manifest.to2}}
            </div>
            <div class="col-1">
              by
              <br>
              {{manifest.by2}}
            </div>
            <div class="col-1">
              To<br>
              {{manifest.to3}}
            </div>
            <div class="col-1">
              by
              <br>
              {{manifest.by3}}
            </div>
            <div class="col-2">
              Currency<br>GBP
            </div>
            <div class="col-2">
              PP X X
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              Airport of Destination<br>
              {{manifest.destination}}
            </div>
            <div class="col-3">
              Flight<br/>
              {{manifest.flight}}

            </div>
          </div>
          <div class="row">
            <div class="col-12">
              Handling information
              <textarea v-model="item.handlingInformation" class="form-control" rows="3"/>

            </div>
          </div>


          <div class="row">
            <div class="col-12 weight-input-container">

            </div>
          </div>
          <div class="row">
            <div class="col-9">
              <table class="table">
                <tr>
                  <th>No</th>
                  <th>GW</th>
                  <th>Kg/lb</th>
                  <th>CW</th>
                  <th>Rate</th>
                  <th>Total</th>
                </tr>
                <tr>
                  <td><input v-model="item.nop" class="form-control"/></td>
                  <td><input v-model="item.gw" class="form-control"/></td>
                  <td>K</td>
                  <td><input v-model="item.cw" class="form-control" @change="updatePrice"/></td>
                  <td><input v-model="item.rateFloat" class="form-control" @change="updatePrice"/></td>
                  <td>{{formatPrice((item.total/100).toFixed(2))}}</td>
                </tr>
                <tr>
                  <td>{{item.nop}}</td>
                  <td>{{item.gw}}</td>
                  <td colspan="4"></td>
                </tr>
              </table>

            </div>
            <div class="col-3">
              Natura and Quantity of Goods
              <textarea v-model="item.goodsDescription" class="form-control" rows="5"/>

            </div>
          </div>

          <div class="row">
            <div class="col-4">

              <table class="table text-center">
                <tr>
                  <th>Prepaid</th>
                  <th colspan="2">Weigth Change</th>
                  <th>Collect</th>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Valuation Charge</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2">{{formatPrice((item.total/100).toFixed(2))}}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Tax</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Total other Charges Due Agent</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2">{{formatPrice( ((Number(item.ahc)+Number(item.fsc)+Number(item.moc)+Number(item.avs))/100).toFixed(2))}}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Total other Charges Due Carrier</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td colspan="2"></td>
                </tr>

                <tr>
                  <th colspan="2">Total Prepaid</th>
                  <th colspan="2">Total Collect</th>
                </tr>
                <tr>
                  <td colspan="2">{{formatPrice( ((Number(item.total) + Number(item.ahc)+Number(item.fsc)+Number(item.moc)+Number(item.avs))/100).toFixed(2))}}</td>
                  <td colspan="2"></td>
                </tr>
              </table>
            </div>
            <div class="col-8">


              <div class="container">
                <div class="row">
<!--                  <div class="col-12">-->
<!--                    Other Charges-->
<!--                    <br>-->
<!--                    {{formatPrice( (item.total/100).toFixed(2))}}-->
<!--                  </div>-->
<!--                  <div class="col-4">-->
<!--                    {{formatPrice( (item.ahc/100).toFixed(2))}} AHC (C)-->
<!--                  </div>-->
<!--                  <div class="col-4">-->
<!--                    {{formatPrice( (item.fsc/100).toFixed(2))}} FSC (C)-->
<!--                  </div>-->
<!--                  <div class="col-4">-->
<!--                    {{formatPrice( (item.moc/100).toFixed(2))}} MOC (C)-->
<!--                  </div>-->
<!--                  <div class="col-4">-->
<!--                    {{formatPrice( (item.avs/100).toFixed(2))}} AVS (C)-->
<!--                  </div>-->
                </div>

                <div class="row">
                  <div class="col-12 text-center">
                    UK Shipping Ltd<br>
                    AS AGENTS FOR {{manifest.issuerTitle}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    Executed on (Date)
                    <input class="form-control" type="date" v-model="item.signedDate"/>

                  </div>
                  <div class="col-4">
                    Executed at (Place)
                    <input class="form-control" v-model="item.executedPlace"/>

                  </div>
                  <div class="col-4">
                    signature
                    <input class="form-control" type="text" v-model="item.signedBy"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="padding:10px;">
              <button class="btn btn-dark" v-on:click="printAirHouse"><i class="fas fa-print"></i> Print AWB</button>

<!--              <button class="btn btn-dark" style="margin-left:20px;" v-on:click="printDeliveryNote"><i class="fas fa-print"></i> Print Delivery Note</button>-->
<!--              Delivery Vehicle: <input type="text" style="width:200px;" v-model="item.vehicleReg"/>-->
            </div>
          </div>
          <div class="row" style="margin-top:20px;">
            <div class="col-6">
              <div class="form-control btn btn-secondary" v-on:click="closeItemForm()">Close</div>
            </div>
            <div class="col-6">
              <div
                class="form-control btn btn-primary" v-on:click="updateItem()"><span v-if="item.id === 0">CREATE</span><span
                v-if="item.id > 0">UPDATE</span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <agent-selector-view
      v-if="agentSelector !== false"
      :on-close="closeAgentSelector"
      :request="agentSelector"></agent-selector-view>
  </div>
</template>
<script>
import {updateAirHouse, updateHouse} from "../api/houses";
import {showDialog} from "../api/utils";
import AgentSelectorView from "./AgentSelectorView.vue";
import {printHawb} from "../api/manifests";
export default {
  name: 'AirHouseView',
  data() {
    return {
      agentSelector: false,
    }
  },
  components: {
    AgentSelectorView
  },
  props: {
    request: {
      type:Object,
      default: function() {return null;}
    },
    item: {
      type:Object,
      default: function(){return null;}
    },
    manifest: {
      type:Object,
      default: function(){return null;}
    },
    onUpdated: {
      type:Function,
      default:null,
    },
    onClose: {
      type: Function,
      default:null,
    },
    onDeleted: {
      type: Function,
      default:null,
    },
    customers: {
      type: Array,
      default:() => [],
    }
  },
  created() {
  },
  mounted() {
    this.onLoaded();
  },
  methods: {
    dummy: function() {

    },
    onLoaded: function() {

    },
    printAirHouse: function() {
      printHawb(this.item.id)
        .then(function(response) {

        })
        .catch(function(err) {

        })
    },
    formatPrice(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    printAwb: function() {

    },
    updateItem: function() {
      let self = this;
      // this.item.cbm = Math.round(parseFloat(this.item.cbmFloat)*100);
      updateAirHouse(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    setConsigneeManual: function() {
      this.item.consigneeId = 0;
      this.item.consigneeTitle = '';
    },
    closeItemForm: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    closeAgentSelector: function() {
      this.$data.agentSelector = false;
    },
    openAgentSelector: function(field, type) {
      let self = this;
      this.$data.agentSelector = {
        type: type,
        onItemSelected: function(item) {

          if(field === 'consignee') {
            self.item.consigneeId = item.id;
            self.item.consigneeTitle = item.title;
            self.item.consigneeAddress1 = item.address1;
            self.item.consigneeAddress3 = item.address2;
            self.item.consigneeAddress3 = item.address3;
            self.item.consigneePostCode = item.postCode;
            // self.item.consigneeTel = item.;

          } else if(field === 'issuer') {
            self.item.issuerId = item.id;
            self.item.issuerTitle = item.title;
            self.item.issuerAddress1 = item.address1;
            self.item.issuerAddress2 = item.address2;
            self.item.issuerAddress3 = item.address3;
            self.item.issuerTel = item.telephone;
          }
        }
      }
    },
    updatePrice: function() {
      this.item.rate = Math.round(parseFloat(this.item.rateFloat)*100);
      this.item.total = this.item.rate*this.item.cw;

    }
  }
}

</script>

<style scoped>
.house-bill>.row>* {
  border: 1px solid #000;
}
.weight-input-container > input {
  height: 38px;
  background: white;
  border: 1px solid #ccc;
  margin-right: 10px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AirHouseView.vue